import React from 'react';
import BaseComponent from './BaseComponent';
import {connect} from 'react-redux';
import classNames from 'classnames';
import {ListItem, ListBody, ListContent, ListTitle, ListIcon} from './UIList';
import Octicon from 'react-octicon';
import {db} from '../firebase';

export class PureEntry extends BaseComponent {
    static get propTypes() {
        return {
            entry: React.PropTypes.object.isRequired,
            showBand: React.PropTypes.bool.isRequired,
            showEvent: React.PropTypes.bool.isRequired,
        };
    }

    static get defaultProps() {
        return {
            showBand: true,
            showEvent: true,
        };
    }

    render() {
        const {entry} = this.props;
        const {favourites, events, venues, showBand, showEvent, entry: {scratched, first_name, surname, band, accompanist, draw}} = this.props;
        const event = events.get(entry.event);
        const venue = venues.get(event.venue);

        const isFavourite = favourites.has(entry.id);

        const icon = <Octicon mega name="star" className={classNames('clickable', {on: isFavourite, off: !isFavourite})} onClick={this.props.favouriteEntry.bind(null, entry.id, !isFavourite)} />;

        const className = classNames('entry', {scratched});

        return <ListItem className={className}>
            <ListBody flex={false} align="center" valign="middle" className="entry-draw">{draw}</ListBody>
            <ListBody>
                <ListTitle>{first_name} {surname}</ListTitle>
                <ListContent>
                    {showBand && <small>{band}</small>}
                    {showBand && showEvent && ' - '}
                    {showEvent && <small>{event.name} - {venue.name}</small>}
                </ListContent>
            </ListBody>
            <ListBody flex={false} align="center" valign="middle" className="entry-state">{this.renderState()}</ListBody>
            <ListBody flex={false} align="center" valign="middle" className="entry-favourite">{icon}</ListBody>
        </ListItem>;
    }

    renderState() {
        const {entry: {scratched, start_time}} = this.props;

        if (scratched) {
            return <ListContent className="entry-state"><large>scratched</large></ListContent>
        }

        if (start_time) {
            return <ListContent className="entry-state">plays approx<br /><large>{start_time.format('HH:mma')}</large></ListContent>
        }

        return;
    }
}

function mapStateToProps({app}) {
    return {
        favourites: app.getIn(['user', 'favourites']),
        events: app.get('events'),
        venues: app.get('venues'),
    };
}

const actions = {
    favouriteEntry(id, shouldFavourite) {
        return (dispatch, getState) => {
            const user = getState().app.get('user');

            const isFavourite = user.favourites.has(id);

            if (isFavourite === shouldFavourite) {
                return; // Nothing needs doing
            }

            dispatch({type: shouldFavourite ? 'addFavourite' : 'removeFavourite', id});

            let action = db.ref(`/users/${user.uid}/favourites/${id}`)
            if (shouldFavourite) {
                action = action.set(true);
            }
            else {
                action = action.remove();
            }
            action
                .catch(error => {
                    console.log('ROLL BACK!');
                    dispatch({type: isFavourite ? 'addFavourite' : 'removeFavourite', id});
                })
            ;
        };
    }

};

export default connect(mapStateToProps, actions)(PureEntry);



/** WEBPACK FOOTER **
 ** ./src/components/Entry.jsx
 **/